module.exports = __webpack_public_path__ + "static/media/UG.cdc93238.png";